import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA5djXRMFBzk9crStjbzKruEzxMXBWpvZE",
  authDomain: "carrera-ciclista-puebla.firebaseapp.com",
  projectId: "carrera-ciclista-puebla",
  storageBucket: "carrera-ciclista-puebla.firebasestorage.app",
  messagingSenderId: "619273960861",
  appId: "1:619273960861:web:121da880990873f692c374"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
export default app;
